import React, { useEffect, useState } from 'react';
import Img from '../../../../../components/Img';

const EventAnimationSectionTypeImg = (props) => {
  const { imgList, transitionDelay } = props;
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!imgList.length) return;

    const interval = setInterval(() => {
      setCurrentIndex(currentIndex + 1 < imgList.length ? currentIndex + 1 : 0);
    }, transitionDelay);
    return () => clearInterval(interval);
  }, [imgList, transitionDelay, currentIndex]);

  if (!imgList.length || !imgList[currentIndex]?.url) return null;
  return <Img clickAble={false} src={imgList[currentIndex].url} />;
};

export default EventAnimationSectionTypeImg;
